import AudioComponent from './AudioComponent'

export default AudioComponent
